import _toConsumableArray from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
import * as echarts from 'echarts';
import chinaGeoJSON from '@/assets/china-border.json';
import xinjiangGeoJSON from '@/assets/xinjiang-border.json';
export default {
  components: {
    pie3d: function pie3d() {
      return import('@/components/pie3d');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      sales_list: [],
      sales_max: 0,
      lab_list: [],
      labId: '',
      labProduction: [],
      labProductionTotal: 0,
      labInfo: {},
      LabReportInfo: {}
    };
  },
  mounted: function mounted() {
    this.init1();
    this.init2();
    this.getSales();
    this.getLab();
    this.init4();
    this.init5();
  },
  destroyed: function destroyed() {
    this.echart1 && this.echart1.dispose();
    this.echart2 && this.echart2.dispose();
    this.echart4 && this.echart4.dispose();
    this.echart5 && this.echart5.dispose();
    this.echart6 && this.echart6.dispose();
  },
  methods: {
    init1: function init1() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, max, valueMap, seriesData, _iterator, _step, item, indicator, key, option;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api['nationalProductionReport']({
                labId: localStorage.getItem('labId'),
                starDate: "".concat(dayjs().format('YYYY'), "-01-01"),
                endDate: "".concat(dayjs().format('YYYY'), "-12-31")
              });
            case 2:
              res = _context.sent;
              max = 0;
              valueMap = {};
              seriesData = [];
              _iterator = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  valueMap[item.breedName] = item.production;
                  seriesData.push(item.production);
                  max = Math.max(item.production, max);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              indicator = [];
              for (key in valueMap) {
                indicator.push({
                  name: key,
                  max: max + max * 0.2
                });
              }
              console.log('max', max, valueMap, indicator);
              _this.echart1 = echarts.init(document.getElementById('chart1'));
              option = {
                backgroundColor: 'transparent',
                tooltip: {
                  trigger: 'item',
                  show: false
                },
                radar: {
                  center: ['50%', '52%'],
                  radius: '70%',
                  splitNumber: 4,
                  startAngle: 90,
                  // 第一个指标固定在【正上方12点钟】
                  shape: 'circle',
                  indicator: indicator,
                  axisName: {
                    fontSize: 16,
                    color: '#fff',
                    formatter: function formatter(name) {
                      return "".concat(name, "  {num|").concat(valueMap[name], "}");
                    },
                    rich: {
                      num: {
                        color: '#35e0ff',
                        fontSize: 16
                      }
                    }
                  },
                  // 轴线样式
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(120,130,145,0.3)'
                    }
                  },
                  // 环形网格线
                  splitLine: {
                    lineStyle: {
                      color: 'rgba(120,130,145,0.3)'
                    }
                  },
                  splitArea: {
                    show: false
                  }
                },
                series: [{
                  type: 'radar',
                  name: '全国养殖产量',
                  symbolSize: 0,
                  // 标记的大小
                  itemStyle: {
                    color: '#FFC67A'
                  },
                  areaStyle: {
                    color: 'rgba(255,198,122,0.4)'
                  },
                  data: [{
                    value: seriesData,
                    areaStyle: {
                      color: 'rgba(255, 228, 52, 0.6)'
                    }
                  }]
                }]
              };
              _this.echart1.setOption(option);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    init2: function init2() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, xAxisData, seriesData, _iterator2, _step2, item, option;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$api['provincialProductionQuery']({
                page: 1,
                limit: 10,
                labId: localStorage.getItem('labId'),
                sortField: 'report_date'
              });
            case 2:
              res = _context2.sent;
              xAxisData = [], seriesData = [];
              _iterator2 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  xAxisData.push(_this2.dateFormat2Str(item.reportDate));
                  seriesData.push(item.production);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _this2.echart2 = echarts.init(document.getElementById('chart2'));
              option = {
                backgroundColor: "transparent",
                legend: {
                  show: false
                },
                tooltip: {
                  show: true,
                  trigger: "axis",
                  //axis , item
                  backgroundColor: "RGBA(0, 49, 85, 1)",
                  borderColor: "rgba(0, 151, 251, 1)",
                  borderWidth: 1,
                  borderRadius: 0,
                  textStyle: {
                    color: "#BCE9FC",
                    fontSize: 16,
                    align: "left"
                  }
                },
                grid: {
                  right: "5%",
                  top: "10%",
                  left: "5%",
                  bottom: "5%",
                  containLabel: true
                },
                xAxis: {
                  type: "category",
                  boundaryGap: true,
                  data: xAxisData,
                  axisLabel: {
                    //坐标轴刻度标签的相关设置。
                    interval: 1,
                    //设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                      color: "#65D5FF",
                      fontStyle: "normal",
                      fontSize: 16
                    }
                  },
                  axisTick: {
                    //坐标轴刻度相关设置。
                    show: false
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#2A4651"
                    }
                  },
                  splitLine: {
                    show: false
                  }
                },
                yAxis: [{
                  type: "value",
                  splitNumber: 3,
                  axisLabel: {
                    textStyle: {
                      color: "#65D5FF",
                      fontStyle: "normal",
                      fontSize: 16
                    }
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#2A4651"
                    }
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: "#2A4651",
                      type: 'dashed'
                    }
                  }
                }],
                series: [{
                  type: "pictorialBar",
                  barWidth: "140%",
                  stack: "总量",
                  label: {
                    show: true,
                    position: 'top',
                    distance: 10,
                    color: '#fff',
                    fontSize: 12
                  },
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                        offset: 0,
                        color: '#1890ff'
                      }, {
                        offset: 1,
                        color: '#1890ff59'
                      }],
                      global: false
                    },
                    // ===== 亮色描边关键配置 =====
                    borderColor: '#48E5E5',
                    // 和顶部亮色保持统一
                    borderWidth: 3
                  },
                  symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                  data: seriesData
                }]
              };
              _this2.echart2.setOption(option);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getSales: function getSales() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$api['regionalSalesQuery']({
                page: 1,
                limit: -1,
                labId: localStorage.getItem('labId'),
                sortField: 'sales'
              });
            case 2:
              res = _context3.sent;
              _this3.sales_list = res.data || [];
              _this3.sales_max = res.data[0].sales + res.data[0].sales * 0.2;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getLab: function getLab() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.$api['labQueryRestricted']({
                page: 1,
                limit: -1
              });
            case 2:
              res = _context4.sent;
              _this4.lab_list = res.data || [];
              _this4.getLabReport();
              _context4.next = 7;
              return _this4.$nextTick(function () {
                _this4.initMap();
              });
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getLabReport: function getLabReport() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.$api['labQueryReport']();
            case 2:
              res = _context5.sent;
              _this5.LabReportInfo = res.data || {};
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    init4: function init4() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res, result, option;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6.$api['marketPriceQuery']({
                page: 1,
                limit: -1,
                labId: localStorage.getItem('labId'),
                sortField: 'report_date'
              });
            case 2:
              res = _context6.sent;
              result = _this6.transformToChart(res.data);
              _this6.echart4 = echarts.init(document.getElementById('chart4'));
              option = {
                backgroundColor: 'transparent',
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  left: 20,
                  top: 10,
                  icon: 'rect',
                  // 方块图标
                  itemWidth: 10,
                  // 方块宽度
                  itemHeight: 10,
                  // 方块高度
                  itemGap: 20,
                  // 图例之间间距
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 14
                  }
                },
                grid: {
                  left: '10%',
                  right: '5%',
                  top: '20%',
                  bottom: '10%'
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: result.xAxis.data,
                  axisLine: {
                    lineStyle: {
                      color: '#BAE7FF'
                    }
                  },
                  axisLabel: {
                    color: '#b8d0e8',
                    fontSize: 12
                  },
                  axisTick: {
                    show: false
                  }
                },
                yAxis: {
                  type: 'value',
                  min: 0,
                  max: 250,
                  splitNumber: 6,
                  axisLine: {
                    show: false
                  },
                  axisLabel: {
                    color: '#89a4c7',
                    fontSize: 12
                  },
                  splitLine: {
                    lineStyle: {
                      color: '#2E2E2E'
                    }
                  }
                },
                series: result.series
              };
              _this6.echart4.setOption(option);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    transformToChart: function transformToChart(rawData) {
      var _this7 = this;
      // 1. 按品种分组
      var grouped = {};
      rawData.forEach(function (item) {
        var name = item.breedName;
        if (!grouped[name]) grouped[name] = [];
        grouped[name].push({
          date: _this7.dateFormat2Str(item.reportDate),
          price: item.price
        });
      });

      // 2. 获取所有日期并排序（去重）
      var allDates = _toConsumableArray(new Set(rawData.map(function (d) {
        return _this7.dateFormat2Str(d.reportDate);
      }))).sort();

      // 3. 预定义颜色（每个品种不同）
      var colorPalette = ['#48E5C7', '#FF6B6B', '#FFD93D', '#6BCBFF', '#A66CFF'];

      // 4. 生成 series
      var series = Object.keys(grouped).map(function (name, index) {
        var dateMap = {};
        grouped[name].forEach(function (d) {
          dateMap[d.date] = d.price;
        });
        var color = colorPalette[index % colorPalette.length];
        return {
          name: name,
          type: 'line',
          smooth: true,
          // 平滑曲线
          symbol: 'none',
          // 不显示数据点标记
          connectNulls: true,
          // ← 关键！让 null 前后连接
          data: allDates.map(function (date) {
            var _dateMap$date;
            return (_dateMap$date = dateMap[date]) !== null && _dateMap$date !== void 0 ? _dateMap$date : null;
          }),
          lineStyle: {
            color: color,
            width: 2
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: color + '4D'
              },
              // 30% 透明度（十六进制）
              {
                offset: 1,
                color: color + '0D'
              } // 5% 透明度
              ]
            }
          }
        };
      });
      return {
        xAxis: {
          type: 'category',
          data: allDates
        },
        series: series
      };
    },
    init5: function init5() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res, data, colorPalette, _iterator3, _step3, item;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.$api['labProductionQuery']({
                page: 1,
                limit: -1,
                sortField: 'report_date'
              });
            case 2:
              res = _context7.sent;
              console.log('res', res.data);
              data = {};
              colorPalette = ['#48E5C7', '#FF6B6B', '#FFD93D', '#6BCBFF', '#A66CFF'];
              _iterator3 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  item = _step3.value;
                  _this8.labProductionTotal += item.production;
                  if (data[item.labId]) {
                    data[item.labId].val += item.production;
                  } else {
                    data[item.labId] = {
                      name: item.labName,
                      val: item.production,
                      itemStyle: {
                        color: colorPalette[Object.values(data).length % colorPalette.length]
                      }
                    };
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              _this8.labProduction = Object.values(data);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    initMap: function initMap() {
      var _this9 = this;
      if (this.map) {
        try {
          this.map.destroy();
        } catch (e) {}
        this.map = null;
        document.getElementById('map').innerHTML = '';
      }
      var T = window.T;

      // 1. 创建地图实例
      this.map = new T.Map("map");
      this.map.centerAndZoom(new T.LngLat(85.0, 42.0), 5);

      // 2. 添加卫星底图（用 TileLayer，而不是 setMapType）
      // 因为 setMapType 可能与热力图覆盖物冲突
      var satelliteLayer = new T.TileLayer('http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=9987072a4193b993c432efa0734c3aed');
      this.map.addLayer(satelliteLayer);

      // 3. 添加影像标注图层（地名、路名）
      var labelLayer = new T.TileLayer('http://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=9987072a4193b993c432efa0734c3aed');
      this.map.addLayer(labelLayer);

      // 4. 绘制国界线（放在最上层）
      this.drawBoundary();
      if (!this.lab_list.length) {
        return;
      }
      this.currentInfoWindow = null;
      this.lab_list.forEach(function (item) {
        var icon = new T.Icon({
          iconUrl: 'https://oss-mng.rich-link.cn/undefined/20260804/1785835721253.png',
          // 图片地址
          iconSize: new T.Point(62, 71),
          // 图片显示大小
          iconAnchor: new T.Point(31, 71) // 图片锚点（底部中心对齐坐标点）
        });
        var marker = new T.Marker(new T.LngLat(item.geoLng, item.geoLat), {
          icon: icon
        });
        marker.addEventListener('click', function () {
          // ✅ 这里的 item 是正确的
          _this9.openInfoWindow(marker, item);
        });
        _this9.map.addOverLay(marker);
      });
    },
    drawBoundary: function drawBoundary() {
      var _this0 = this;
      var T = window.T;

      // 从 GeoJSON 中提取所有坐标点
      var allCoordinates = this.extractAllCoordinates(xinjiangGeoJSON);

      // 如果数据太大，可以只绘制前几个省份来测试
      // 这里绘制所有省份
      allCoordinates.forEach(function (coords) {
        // 将坐标数组转换为 T.LngLat 对象数组
        var points = coords.map(function (coord) {
          return new T.LngLat(coord[0], coord[1]);
        });

        // 创建多边形覆盖物（带填充和边框）
        var polygon = new T.Polygon(points, {
          color: '#FFD700',
          weight: 3,
          opacity: 0.9,
          dashArray: '8,4',
          // 实线8px + 空隙4px 交替虚线
          fillColor: 'rgba(255, 215, 0, 0.08)',
          fillOpacity: 0.08,
          lineCap: 'round'
        });
        _this0.map.addOverLay(polygon);
      });
    },
    openInfoWindow: function openInfoWindow(marker, item) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var content;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              console.log('openInfoWindow', marker, item);
              // ✅ 先关闭上一个信息窗
              if (_this1.currentInfoWindow) {
                console.log('this.currentInfoWindow', _this1.currentInfoWindow);
                _this1.currentInfoWindow.closeInfoWindow();
                _this1.currentInfoWindow = null;
              }

              // 创建新信息窗
              content = "\n            <div class=\"customInfoWindow\">\n            <div class=\"title\">".concat(item.name, "</div>\n            <div class=\"info\">\n                <div style=\"width:100%\">\n                    <div class=\"label\">\u517B\u6B96\u6A21\u5F0F</div>\n                    <div class=\"value\">").concat(item.cultureMode || '--', "</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u5360\u5730\u9762\u79EF</div>\n                    <div class=\"value\">").concat(item.cultureArea || '--', " \u4EA9</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u517B\u6B96\u6C34\u4F53</div>\n                    <div class=\"value\">").concat(item.cultureWaterBody || '--', " m\xB3</div>\n                </div>\n            </div>\n            <div class=\"num\">\n                <div>\n                    <div class=\"label\">\u91C7\u96C6\u5668</div>\n                    <div class=\"value\">").concat(item.amountCollector || 0, "</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u4F20\u611F\u5668</div>\n                    <div class=\"value\">").concat(item.amountSensor || 0, "</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u6295\u9972\u673A</div>\n                    <div class=\"value\">").concat(item.amountFeeder || 0, "</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u6444\u50CF\u5934</div>\n                    <div class=\"value\">").concat(item.amountCamera || 0, "</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u65E0\u4EBA\u673A</div>\n                    <div class=\"value\">").concat(item.amountUav || 0, "</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u65E0\u4EBA\u8239</div>\n                    <div class=\"value\">").concat(item.amountUsv || 0, "</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u673A\u5668\u4EBA</div>\n                    <div class=\"value\">").concat(item.amountRobot || 0, "</div>\n                </div>\n                <div>\n                    <div class=\"label\">\u65E0\u4EBA\u8F66</div>\n                    <div class=\"value\">").concat(item.amountUgv || 0, "</div>\n                </div>\n            </div>\n            </div>\n        ");
              _this1.currentInfoWindow = new T.InfoWindow(content, {
                offset: new T.Point(0, -32)
              });

              // 打开信息窗并保存引用
              marker.openInfoWindow(_this1.currentInfoWindow);
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getLabInfo: function getLabInfo(id) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var res;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this10.$api['labDetail'](id);
            case 2:
              res = _context9.sent;
              return _context9.abrupt("return", res.data || {});
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    }
    /**
     * 递归提取 GeoJSON 中所有坐标点
     * 支持 Polygon 和 MultiPolygon 类型
     */
    ,
    extractAllCoordinates: function extractAllCoordinates(geojson) {
      var result = [];
      var _extract = function extract(geometry) {
        if (!geometry) return;
        if (geometry.type === 'Polygon') {
          // Polygon: coordinates 是 [外环, 内环1, 内环2, ...]
          // 我们只取外环（索引0）来绘制整体轮廓
          result.push(geometry.coordinates[0]);
        } else if (geometry.type === 'MultiPolygon') {
          // MultiPolygon: coordinates 是 [[外环, 内环...], [外环, 内环...], ...]
          geometry.coordinates.forEach(function (polygon) {
            result.push(polygon[0]); // 只取每个多边形的外环
          });
        } else if (geometry.type === 'GeometryCollection') {
          geometry.geometries.forEach(function (geom) {
            return _extract(geom);
          });
        }
      };

      // 遍历所有 features
      if (geojson.features) {
        geojson.features.forEach(function (feature) {
          _extract(feature.geometry);
        });
      } else {
        _extract(geojson);
      }
      return result;
    },
    backClick: function backClick() {
      this.$router.back();
    },
    openClick: function openClick(str) {
      this.openStr = str;
      this.open = true;
    }
  }
};